import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Password } from './password';
import { UserAccount } from './user-account';
import { UserEmail } from './user-email';
import { UserInfo } from './user-info';
import { ACCOUNT_ADMIN_PERMISSIONS, ADMIN_PERMISSIONS, isAuthorized, REVIEWER_PERMISSIONS, SUPPORT_ADMIN_PERMISSIONS } from 'security/authorization';
import { useGlobalState } from 'store/reducers/reducer';
export const Profile = () => {
    const { state } = useGlobalState();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const isAdmin = state.user
        ? isAuthorized(state.user, ADMIN_PERMISSIONS)
        : false;
    const isSupport = state.user
        ? isAuthorized(state.user, SUPPORT_ADMIN_PERMISSIONS)
        : false;
    const isReviewer = state.user
        ? isAuthorized(state.user, REVIEWER_PERMISSIONS)
        : false;
    const isAccountAdmin = state.user
        ? isAuthorized(state.user, ACCOUNT_ADMIN_PERMISSIONS)
        : false;
    useEffect(() => {
        if (isReviewer && pathname !== '/account') {
            navigate('/account/jobs');
        }
    }, [isReviewer, pathname, navigate]);
    return (React.createElement("div", { className: "profile-main" },
        React.createElement("h1", { className: "g-page-name" }, "Profile"),
        React.createElement(UserEmail, null),
        React.createElement(UserInfo, null),
        React.createElement(Password, null),
        (isAdmin || isSupport || isAccountAdmin) && React.createElement(UserAccount, null)));
};
